<template>
  <figure class="player embed" :class="wrapperClasses">
    <div v-if="hasPreview" class="overlay" v-on:click="togglePlaymode()">
      <img :src="previewSrc">
    </div>
    <iframe v-if="playing" :src="src" :width="width" :height="height"></iframe>
  </figure>
</template>
<script>
export default {
  name: "VueEmbedplayer",
  data: function() {
    return {
      playing: false
    };
  },
  props: {
    media: {
      type: Object
    },
    current: {
      type: String,
      default: ""
    }
  },
  methods: {
    togglePlaymode() {
      this.playing = !this.playing;
      this.$on("media", function(uri) {
        if (uri !== this.media.src) {
          this.playing = false;
        }
      });
      if (this.playing) {
        if (this.media.src) {
          //this.$parent.mediaPlaying = this.media.src;
        }
      }
    }
  },
  computed: {
    wrapperClasses() {
      let cls = this.playing ? ["playing"] : ["preview"];
      let [w, h] = this.aspect;
      cls.push("aspect-" + w + "-" + h);
      return cls;
    },
    aspect() {
      let aspect = [16, 9];
      if (this.media.aspect) {
        if (
          this.media.aspect instanceof Array &&
          this.media.aspect.length > 1
        ) {
          aspect = this.media.aspect;
        }
      }
      return aspect;
    },
    width() {
      let w = 768;
      return w;
    },
    height() {
      let [wi, he] = this.aspect;
      return this.width / (wi / he);
    },
    src() {
      let src = "#";
      if (this.media.src) {
        src = this.media.src;
      }
      return src;
    },
    previewSrc() {
      let src = "#";
      if (this.media.preview_src) {
        src = this.media.preview_src;
      }
      return src;
    },
    hasSrc() {
      return this.src.length > 3;
    },
    hasPreview() {
      return this.previewSrc.length > 3;
    }
  },
  watch: {
    current() {
      if (this.current !== this.media.src) {
        this.playing = false;
      }
    }
  }
};
</script>